import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography
} from "@mui/material";
import ResponsiveButton from "components/ResponsiveButton";

type Props = {
	open: boolean;
	affectedVehicles: string[];
	isBulk: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export default function DeactivateDriverWarningDialog({
	open,
	affectedVehicles,
	isBulk,
	onConfirm,
	onCancel
}: Props) {
	return (
		<Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
			<DialogTitle
				variant="text20Bold"
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					p: 2,
					borderBottom: 1,
					borderColor: "divider"
				}}
			>
				Driver assigned to fleet vehicles
				<IconButton onClick={onCancel} size="small" aria-label="Close">
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent sx={{ p: 2, pt: "16px !important" }}>
				<Box>
					<Typography variant="text14">
						{isBulk
							? "One or more selected users are assigned as a default driver on the following vehicle(s):"
							: "This user is assigned as a default driver on the following vehicle(s):"}
					</Typography>
					<Box component="ul" sx={{ mt: 1, pl: 2, mb: 0 }}>
						{affectedVehicles.map((reg) => (
							<Typography component="li" variant="text14" key={reg}>
								{reg}
							</Typography>
						))}
					</Box>
					<Typography variant="text14" sx={{ mt: 1, display: "block" }}>
						Deactivating will not remove them from these vehicles. Do you want to proceed?
					</Typography>
				</Box>
			</DialogContent>

			<DialogActions
				disableSpacing
				sx={{
					borderTop: 1,
					borderColor: "divider",
					flexDirection: { xs: "column-reverse", sm: "row" },
					justifyContent: "flex-end",
					gap: 2,
					p: 2
				}}
			>
				<ResponsiveButton variant="text" onClick={onCancel}>
					Cancel
				</ResponsiveButton>
				<ResponsiveButton variant="contained" color="error" onClick={onConfirm}>
					Deactivate
				</ResponsiveButton>
			</DialogActions>
		</Dialog>
	);
}
